import script from "./EditStudentView.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditStudentView.vue?vue&type=script&lang=ts&setup=true"

import "./EditStudentView.vue?vue&type=style&index=0&id=e1e7abba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1e7abba"]])

export default __exports__